import React from 'react';
import { connect } from 'react-redux';
import { CMSContent, hasCMSContent, DisplayContent } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const PrivacyPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <DisplayContent note='Privacy Policy section' isVisible={hasCMSContent('data.legalAndPolicyItems.privacyPolicy.contentHTML')}>
                <div className='enter-container container-fluid'>
                    <div className='row justify-content-center'>
                        <div className='entry-box col-10'>
                            <h2 className='text-center my-4'>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.legalAndPolicyItems.privacyPolicy.contentHeaderText'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                />
                            </h2>
                            <div>
                                <CMSContent
                                    localStorageObject='webContent'
                                    contentPath='data.legalAndPolicyItems.privacyPolicy.contentHTML'
                                    cmsSourceFirebase={cmsSourceFirebase}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPage);
